import { takeEvery, call, put } from "redux-saga/effects";
import {
  TRIGGER_RESEARCH_DECK_REQUEST,
  TRIGGER_RESEARCH_DECK_SUCCESS,
  TRIGGER_RESEARCH_DECK_FAILURE,
  TRIGGER_DECK_CONFIRM_DIAGRAM_SCOPE_REQUEST,
  TRIGGER_DECK_CONFIRM_DIAGRAM_SCOPE_SUCCESS,
  TRIGGER_DECK_CONFIRM_DIAGRAM_SCOPE_FAILURE,
  TRIGGER_DECK_REFINE_DIAGRAM_REQUEST,
  TRIGGER_DECK_REFINE_DIAGRAM_SUCCESS,
  TRIGGER_DECK_REFINE_DIAGRAM_FAILURE,
} from "../actions/researchDeckActions";
import {
  triggerResearchDeckApi,
  triggerDeckConfirmDiagramScopeApi,
  triggerDeckRefineDiagramApi,
} from "../apis/researchDeckApi";

function* triggerResearchDeck(action) {
  try {
    const result = yield call(triggerResearchDeckApi, action.payload);
    yield put({ type: TRIGGER_RESEARCH_DECK_SUCCESS, payload: result });
  } catch (error) {
    yield put({ type: TRIGGER_RESEARCH_DECK_FAILURE, error: error.message });
  }
}

function* triggerDeckConfirmDiagramScope(action) {
  try {
    const result = yield call(triggerDeckConfirmDiagramScopeApi, action.payload);
    yield put({ type: TRIGGER_DECK_CONFIRM_DIAGRAM_SCOPE_SUCCESS, payload: result });
  } catch (error) {
    yield put({
      type: TRIGGER_DECK_CONFIRM_DIAGRAM_SCOPE_FAILURE,
      error: error.message,
    });
  }
}

function* triggerDeckRefineDiagram(action) {
  try {
    const result = yield call(triggerDeckRefineDiagramApi, action.payload);
    yield put({ type: TRIGGER_DECK_REFINE_DIAGRAM_SUCCESS, payload: result });
  } catch (error) {
    yield put({
      type: TRIGGER_DECK_REFINE_DIAGRAM_FAILURE,
      error: error.message,
    });
  }
}

export default function* researchDeckSaga() {
  yield takeEvery(TRIGGER_RESEARCH_DECK_REQUEST, triggerResearchDeck);
  yield takeEvery(
    TRIGGER_DECK_CONFIRM_DIAGRAM_SCOPE_REQUEST,
    triggerDeckConfirmDiagramScope,
  );
  yield takeEvery(TRIGGER_DECK_REFINE_DIAGRAM_REQUEST, triggerDeckRefineDiagram);
}
